// extracted by mini-css-extract-plugin
module.exports = {"code-block":"HighlightedCode_code-block__39XFE"};